import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-714e6700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apdex-app-list-tab-container" }
const _hoisted_2 = { class: "apdex-app-list-status" }
const _hoisted_3 = { class: "apdex-app-list-respTime" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import DataRetentionTabs from '@/components/Settings/DataRetentionTabs.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import {
  APDEX_APPLIST_TABS,
  HEALTH_STATUSES,
  APDEX_APPLIST_HEADERS,
  DEFAULT_APP_LIST,
  DEFAULT_PAGE,
} from '@/components/Home/revamp/util.js';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import RexSearch from '@/rex-components/rex-search.vue';
import RexTableCompV2 from '@/rex-components/rex-TableCompV2.vue';
import { ref, computed, onMounted, watch } from 'vue';
import { useActions, useGetters } from '@/utils/useMappers';
import {
  Props,
  AppListDataType,
  Tab,
  SearchParam,
  Status,
  ListRecord,
} from '@/components/Home/revamp/home.types';
import {
  parseApdex,
  parseServiceObjFromApplication,
} from '@/utils/helper-function';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApdexAppList',
  props: {
    showModal: {},
    onClose: { type: Function },
    apdexApplistStatus: {}
  },
  setup(__props: any) {

const [getApdexAppList, selectBrowserService] = useActions([
  'homeState/getApdexAppList',
  'browserState/browserCommonState/selectBrowserService',
]);
const { showModal, onClose, apdexApplistStatus } = __props;

const router = useRouter();

const currentTab = ref(APDEX_APPLIST_TABS()[0]);
const loading = ref(false);
const searchText = ref('');
const healthStatuses = computed(() => HEALTH_STATUSES());
const currentStatus = ref(apdexApplistStatus || HEALTH_STATUSES()[0]);
const headers = computed(() => APDEX_APPLIST_HEADERS());
const appListData = ref<AppListDataType>(DEFAULT_APP_LIST);
const currentPage = ref(DEFAULT_PAGE);

const [getTimeDuration, teamId] = useGetters([
  'globalState/settings/getDurationTime',
  'globalState/user/getTeamId',
]);

const tabItems = computed(function () {
  return APDEX_APPLIST_TABS();
});

const allowInfiniteScroll = computed(function () {
  return appListData.value.records.length < appListData.value.total;
});

const handleClose = () => {
  onClose();
};
const clearSearch = () => {
  searchText.value = '';
  handleSearch({
    text: '',
  });
};

const onTabClick = (data: Tab) => {
  currentTab.value = data;
  searchText.value = '';
};
const selectStatus = (status: Status) => {
  currentStatus.value = status;
};
const handleSearch = (searchParam: SearchParam) => {
  searchText.value = searchParam.text;
  currentPage.value = DEFAULT_PAGE;
  fetchAppList(true);
};
const fetchAppList = async (reset = false) => {
  const params = {
    condition: {
      keyword: searchText.value,
      filterCondition: {
        scope: 'Service',
        metricType: 'ALERTS',
        order: 'DES',
        apdexHealth: currentStatus.value.key,
      },
      pagination: {
        pageNum: currentPage.value,
        pageSize: 10,
        needTotal: true,
      },
      duration: getTimeDuration.value,
      serviceReq: {
        capability: currentTab.value.serviceType,
        teamID: teamId.value,
        checkCorrelation: true,
        correlatedCapability: 'V',
      },
    },
  };
  try {
    if (reset === true) {
      appListData.value = DEFAULT_APP_LIST;
      loading.value = true;
    }
    const res: AppListDataType = await getApdexAppList(params);
    const dataWithUpdatedApdex = res.records.map((record) => ({
      ...record,
      apdex: parseApdex(record.apdex),
    }));
    appListData.value = {
      total: res.total,
      records: [
        ...(!reset ? appListData.value.records : []),
        ...dataWithUpdatedApdex,
      ],
    };
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};

const redirectToAPM = (item: ListRecord) => {
  if (currentTab.value.serviceType.toLowerCase() === 'browser') {
    router.push({
      name: currentTab.value.serviceType.toLowerCase(),
      query: {
        id: item.serviceID,
      },
    });
  } else {
    router.push({
      name: currentTab.value.serviceType.toLowerCase(),
      query: {
        id: item.serviceID,
      },
    });
  }
};

onMounted(() => {
  fetchAppList();
});

watch(currentStatus, () => {
  currentPage.value = DEFAULT_PAGE;
  fetchAppList(true);
});

watch(currentTab, () => {
  currentPage.value = DEFAULT_PAGE;
  fetchAppList(true);
});

watch(apdexApplistStatus, (newValue) => {
  currentStatus.value = newValue;
});

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createBlock(RexModalV3, {
    show: _ctx.showModal,
    onOnClose: handleClose,
    title: _ctx.$t('apdexTitle'),
    enableFooter: true,
    width: "50rem"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(DataRetentionTabs, {
          items: tabItems.value,
          selectedItem: currentTab.value.name,
          onOnClick: onTabClick
        }, null, 8, ["items", "selectedItem"]),
        _createElementVNode("div", _hoisted_1, [
          (currentTab.value.serviceType === tabItems.value[0].serviceType)
            ? (_openBlock(), _createBlock(RexSearch, {
                key: 0,
                width: "100%",
                placeholder: _ctx.$t('searchApplication'),
                onSearch: handleSearch,
                onClearSelection: clearSearch,
                class: "apdex-app-list-search"
              }, null, 8, ["placeholder"]))
            : (_openBlock(), _createBlock(RexSearch, {
                key: 1,
                width: "100%",
                placeholder: _ctx.$t('searchApplication'),
                onSearch: handleSearch,
                onClearSelection: clearSearch,
                class: "apdex-app-list-search"
              }, null, 8, ["placeholder"])),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('healthStatus')), 1),
            _createVNode(RexSearchSelect, {
              width: "10rem",
              current: currentStatus.value,
              data: healthStatuses.value,
              onOnChoose: selectStatus,
              objectValueIndex: 1,
              id: "apdex-app-list-status",
              isSearch: false
            }, null, 8, ["current", "data"])
          ])
        ]),
        _createVNode(RexTableCompV2, {
          headers: headers.value,
          items: appListData.value.records,
          loading: loading.value,
          variant: "secondary",
          itemHeight: 63.5,
          onFetchNextPageData: _cache[0] || (_cache[0] = 
            () => {
              if (allowInfiniteScroll.value) {
                currentPage.value++;
                fetchAppList();
              }
            }
          ),
          enableScrollFooter: allowInfiniteScroll.value,
          enableInfiniteScroll: true,
          height: "30rem"
        }, _createSlots({
          "body-respTime": _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(item.respTime) + " ", 1),
              _createElementVNode("div", {
                onClick: () => redirectToAPM(item)
              }, [
                _createVNode(_component_BaseIcon, {
                  name: "redirectTimeSM",
                  class: "apdex-app-list-redirect-icon",
                  width: "1.2rem"
                })
              ], 8, _hoisted_4)
            ])
          ]),
          "body-apdex": _withCtx(({ item }) => [
            _createElementVNode("div", {
              class: _normalizeClass(`apdex-app-list-${currentStatus.value.key.toLowerCase()}`)
            }, _toDisplayString(item.apdex), 3)
          ]),
          _: 2
        }, [
          _renderList(headers.value, (header) => {
            return {
              name: `header-${header.key}`,
              fn: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(header.name), 1)
              ])
            }
          })
        ]), 1032, ["headers", "items", "loading", "enableScrollFooter"])
      ])
    ]),
    footer: _withCtx(() => [
      _hoisted_5
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})